import EcoImg from 'eco-design/base/eco-img';
import EcoCartMinus from '../../icons/EcoCartMinus';
import EcoCartPlus from '../../icons/EcoCartPlus';
import EcoCartTrash from '../../icons/EcoCartTrash';
import { ItfEcoCartItem } from '../../type';
import './index.scss';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import getLocal from 'eco-design-reliance/getLocal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT } from '../../type.d';
import { ECO_CART_DEFAULT_SKU_TITLE, MAX_CART_NUM, MIN_CART_NUM } from '../../const';
import EcoCartCoupon from '../EcoCartCoupon';
import useEcoCart from '../../useEcoCart';

const EcoCartItems: React.FC = () => {
    const { locale = '' } = getLocal();
    const { items } = useEcoCart();

    const handleItemIncrease = (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_INCREASE, item);
    };

    const handleItemDecrease = (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_DECREASE, item);
    };

    const handleItemRemove = (item: ItfEcoCartItem) => {
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_REMOVE, item);
    };

    return (
        <ul className="eco-cart-items">
            {items?.map((item: ItfEcoCartItem) => (
                <li className="eco-cart-item" key={`${item.variantId}`}>
                    <div className="eco-cart-item-img">
                        <EcoImg pc={item.variantImg || item.img} alt={item.productTitle || item.skuTitle} />
                    </div>
                    <div className="eco-cart-item-content">
                        {(item.productTitle || item.skuTitle) && <p className="eco-cart-item-product-title">{item.productTitle || item.skuTitle}</p>}
                        {item.skuTitle &&
                            item.skuTitle !== item.productTitle &&
                            item.productTitle &&
                            item.skuTitle?.toUpperCase() !== ECO_CART_DEFAULT_SKU_TITLE && <p className="eco-cart-item-sku-title">{item.skuTitle}</p>}
                        <div className="eco-cart-item-control">
                            <div className="eco-cart-item-calculator">
                                <div
                                    className={`calc-increase calc-btn${item.quantity <= MIN_CART_NUM ? ' disabled' : ''}`}
                                    onClick={() => handleItemDecrease(item)}
                                >
                                    <EcoCartMinus />
                                </div>
                                <span className="calc-num">{Math.min(MAX_CART_NUM, Math.max(MIN_CART_NUM, item.quantity))}</span>
                                <div
                                    className={`calc-decrease calc-btn${
                                        item.quantity >= (item.inventoryPolicy === 'continue' ? MAX_CART_NUM : Math.min(MAX_CART_NUM, item.inventoryQuantity))
                                            ? ' disabled'
                                            : ''
                                    }`}
                                    onClick={() => handleItemIncrease(item)}
                                >
                                    <EcoCartPlus />
                                </div>
                            </div>
                            <div className="eco-cart-item-remove-icon" onClick={() => handleItemRemove(item)}>
                                <EcoCartTrash />
                            </div>
                            <div className="eco-cart-item-price">
                                <span className="item-price">{FormatMoneyLocal(item.price, locale)}</span>
                                {item.price !== item.compareAtPrice && item.compareAtPrice > 0 && (
                                    <span className="item-compare-price">{FormatMoneyLocal(item.compareAtPrice, locale)}</span>
                                )}
                            </div>
                        </div>
                        <EcoCartCoupon item={item} />
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default EcoCartItems;
